module.exports = __webpack_public_path__ + "img/Frame-48.228197b3.svg";